<template>    
    <div class="col-12 px-0 form-group">
        <label :for="name" class="col-12 px-0">{{labels.ssn}}</label>
        <input v-if="!isDisabled && editing" ref="ssn" type="text" aria-required="true" class="col-12 form-control" v-bind:class="{'error': needToShowError}" maxlength="9" :id="name" :name="name" inputmode="numeric" v-model="value" @blur="onSsnBlur">
        <input v-else-if="!isDisabled && !editing" type="text" aria-required="true" class="col-12 form-control" v-bind:class="{'error': needToShowError}" maxlength="9" :id="name" :name="name" v-model="maskedValue" @focus="edit">
        <input v-else type="text" aria-required="true" class="col-12 form-control" :id="name" :name="name" v-model="maskedValue" readonly>
        <p v-if="needToShowError" class="error-msg mt-2" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{labels.ssnErrorMsg}}</p>
    </div>
</template>

<script>
    import {nextTick} from 'vue';

    export default {
        name: "SSN",

        emits: ['set-tax-id'],

        props: {
            labels: Object,
            name: String,
            isDisabled: Boolean,
        },

        data: function() {
            return {
                value: "",
                editing: false,
                maskStart: "*****",
                maskValue: "#########",
                inError: false,
                showError: false
            }
        },

        methods: {
            setValue: function(val) {
                this.value = val;
            },

            edit: function() {
                this.editing = true;
                nextTick(() => this.$refs['ssn'].focus());
            },

            setInError: function() {
                this.inError = !(this.value !== "" && this.value.match(/^\d{9}$/));
            },

            onSsnBlur: function() {
                this.showError = true
                this.setInErrorAndEmitValue();
            },

            setInErrorAndEmitValue: function() {
                this.setInError();
                this.$emit('set-tax-id', !this.inError ? this.value : "");
            },

            clear: function() {
                this.value = "";
            }
        },

        watch: {
            value: function() {
                this.showError = false;
                this.setInErrorAndEmitValue();
            }
        },

        computed: {
            maskedValue: function() {
                var masked = "";

                if (this.value.length > 5) {
                    masked = this.maskStart + this.value.substr(5);
                }
                else {
                    masked = this.maskStart.substr(0, this.value.length);
                }

                return masked;
            },
            needToShowError: function() {
                return this.inError && this.showError;
            }
        }
    }
</script>